<template>
  <ion-page>
    <ion-content :fullscreen="true">
      
    <div class="centered-content">
      <div class="ion-text-center">
        <OfflineImage class="offline-image"></OfflineImage>
      </div>
      <h6 class="ion-text-center no-internet">No Internet</h6>
      <div class="ion-text-center">Please check internet connection.</div>
    </div>

    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
/*
  imports
*/
import { IonContent, IonPage } from '@ionic/vue';
import OfflineImage from "../components/images/OfflineImage.vue"
</script>
<style scoped>
.centered-content {
  display: flex;
  flex-direction: column; 
  justify-content: center;
  align-items: center;
  height: 100vh; /* Set the height of the container to fill the viewport */
}

.no-internet{
  font-weight: bold;
}

.offline-image {
  max-width: 100%;
}


@media screen and (min-width: 992px) {
  .offline-image {
    width: 500px;
    height: 500px;
  }
}


</style>
